<script setup>
const props = defineProps({
  pendingSubmissions: {
    type: Array,
    required: true,
  },
  pendingSubmissionColumns: {
    type: Array,
    required: true,
  },
});
import { ElTableColumn, ElTable } from "element-plus";
import { onMounted, ref } from "vue";

const emit = defineEmits(["prefill"]);

const tableData = ref([]);
const submissionData = ref(new Map());
const tableColumns = ref([]);

onMounted(() => {
  props.pendingSubmissions.forEach((submission) => {
    tableData.value.push({
      ...submission.submittedData,
      uuid: submission.uuid,
      draftId: submission.draftId,
    });
    submissionData.value.set(submission.uuid, {
      ...submission.data,
      uuid: submission.uuid,
      draftId: submission.draftId,
    });
  });

  props.pendingSubmissionColumns.forEach((column) => {
    if (column.nestedColumns?.length > 0) {
      column.nestedColumns.forEach((nestedColumn) => {
        tableColumns.value.push({
          prop: `${column.columnName}_${nestedColumn.columnName}`,
          label: nestedColumn.columnName,
        });
      });
    } else {
      tableColumns.value.push({
        prop: column.columnName,
        label: column.columnName,
      });
    }
  });
});

const handleRowClick = (row, column, event) => {
  const { draftId } = row;
  const formattedData = submissionData.value.get(row.uuid);

  emit("prefill", draftId, formattedData);
};
</script>

<template>
  <div class="table-container pending-submissions-list">
    <ElTable :data="tableData" style="width: 100%" @row-click="handleRowClick">
      <ElTableColumn
        v-for="column in tableColumns"
        :key="column.prop"
        :label="column.label"
        :prop="column.prop"
        width="180"
      />
    </ElTable>
  </div>
</template>

<style>
.pending-submissions-list .el-table__body .el-table__row {
  cursor: pointer;
}
</style>

<style scoped>
.table-container {
  border: 1px solid var(--color-border-dark);
  border-radius: 4px;
  padding: 4px;
}
</style>
